const axios = require('@/utils/axios')
const {baseURL} = require('@/assets/js/config')
const $http = axios.create({
	baseURL
})

const state = {
	kids : [],
	current_kid : null,
}

const getters = {
	fetchKids : (state) => state.kids,
	fetchCurrentKid : (state) => state.current_kid,
}

const actions = {
	loadKids({commit}, {token}){
		return $http.get(`kid`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_KIDS', response.data)
		})
	},

	loadKidDetails({commit}, {id, token}){
		return $http.get(`kid/${id}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_CURRENT_KID', response.data)
		})
	},

	createKid({commit}, {kid, token}){		
		return $http.post('kid', kid, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('ADD_KID', response.data)
		})
	},

	updateKid({commit}, {id, kid, token}){		
		return $http.put(`kid/${id}`, kid, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('UPDATE_KID', response.data)
		})
	},

	deleteKid({commit}, {kid_obj, token}){
		return $http.delete(`kid/${kid_obj.kid}`, {
			headers : {
				'x-auth-token' : token
			} 
		}).then((response) => {
			if(response.data.n > 0){
				commit('REMOVE_KID', kid_obj.kid)	
			}
			
		})
	},
}

const mutations = {
	SET_KIDS : (state, kids) => {
		state.kids = kids
	},
	SET_CURRENT_KID : (state, kid) => {
		state.current_kid = kid
	},
	ADD_KID : (state, kid) => {
		state.kids.unshift(kid)
	},
	UPDATE_KID : (state, kid) => {
		state.current_kid = kid
	},
	REMOVE_KID : (state, kid_id) => {
		const kid_index = state.kids.map((kid) => kid._id).indexOf(kid_id)
		state.kids.splice(kid_index, 1)
	},
}

export default {
	state, getters, actions, mutations
}